{
  "title": "Dashboard",
  "welcome": "Welcome back, {{name}}",
  "overview": {
    "title": "Overview",
    "studentsActive": "Active Students",
    "lessonsCompleted": "Lessons Completed",
    "averageProgress": "Average Progress",
    "upcomingAssessments": "Upcoming Assessments"
  },
  "students": {
    "title": "Students",
    "add": "Add Student",
    "search": "Search students...",
    "table": {
      "name": "Name",
      "grade": "Grade",
      "progress": "Progress",
      "lastActive": "Last Active",
      "actions": "Actions"
    }
  },
  "curriculum": {
    "title": "Curriculum",
    "subjects": "Subjects",
    "lessons": "Lessons",
    "assignments": "Assignments",
    "assessments": "Assessments"
  },
  "analytics": {
    "title": "Analytics",
    "performance": "Performance",
    "engagement": "Engagement",
    "completion": "Completion Rate",
    "timeSpent": "Time Spent"
  },
  "notifications": {
    "title": "Notifications",
    "new": "New",
    "markAllRead": "Mark all as read",
    "noNotifications": "No new notifications"
  }
}
